<template lang="pug">
v-container.page-home-unesco.py-8.py-sm-16.d-flex.flex-column.align-center
  img(src="/img/unesco.png")
  .text-body-2.text-sm-h6.text-center.mt-4.font-weight-bold(v-text="text")
</template>

<script>
export default {
  data: () => ({
    text:
      "O colégio Jean Piaget Sinop, está alinhado com os objetivos do Desenvolvimento e Sustentabilidade (ODS - 17) da Unesco.",
  }),
};
</script>

<style>
.page-home-unesco img {
  max-width: 640px;
  width: 100%;
}
.page-home-unesco div {
  max-width: 590px;
}
</style>
